import { render, staticRenderFns } from "./FileStructureDataModal.vue?vue&type=template&id=40edf1c6"
import script from "./FileStructureDataModal.vue?vue&type=script&lang=ts"
export * from "./FileStructureDataModal.vue?vue&type=script&lang=ts"
import style0 from "./FileStructureDataModal.vue?vue&type=style&index=0&id=40edf1c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports